import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    useDataProvider,
    DataProviderContext,
    Button,
} from 'react-admin';
import { useMemo, useState } from 'react';
import FormattedDateTimeField from '../../../common/FormattedDateTimeField';
import { NoDataSection } from '../../../common/NoDataSection';
import MonthSelector from '../../../common/MonthSelector';
import { createCustomGoDataProvider, goApi } from '../../../services';
import { Download } from 'lucide-react';

const ReportBatchStudentList = () => {
    const getCurrentMonthRange = () => {
        const now = new Date();

        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        const formatDate = (date: Date) => date.toISOString().split('T')[0];
        const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

        return {
            firstDay: formatDate(firstDay),
            lastDay: formatDate(lastDay),
            month,
        };
    };

    const [selectedMonthRange, setSelectedMonthRange] = useState(getCurrentMonthRange);
    const baseDataProvider = useDataProvider();

    const listFilter = useMemo(() => {
        return selectedMonthRange ? { monthYear: selectedMonthRange.month } : {};
    }, [selectedMonthRange]);

    const customDataProvider = useMemo(() => {
        const dp = createCustomGoDataProvider(baseDataProvider, [
            { resource: 'report_batch_students', apiEndpoint: '/batches/reports/enrollments' },
        ]);

        dp.downloadBatchStudentsReport = async (filters: any = {}) => {
            const query = new URLSearchParams(filters).toString();
            const response = await goApi.get(`/batches/reports/enrollments/download?${query}`);
            return response.data;
        };

        return dp;
    }, [baseDataProvider]);

    const handleDownload = async () => {
        try {
            const response = await customDataProvider.downloadBatchStudentsReport(listFilter);
            const fileUrl = response?.url || response?.data?.url;

            if (fileUrl) {
                window.open(fileUrl, '_blank', 'noopener,noreferrer');
            } else {
                console.error('Download URL missing');
            }
        } catch (error) {
            console.error('Download failed', error);
        }
    };

    const ListActions = () => (
        <TopToolbar>
            <MonthSelector
                monthsToShow={12}
                setSelectedMonthRange={setSelectedMonthRange}
                selectedMonthRange={selectedMonthRange}
            />
            <Button label="Export" onClick={handleDownload} startIcon={<Download />} />
        </TopToolbar>
    );

    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <ListActions />
            <List
                resource={'report_batch_students'}
                actions={false}
                filter={listFilter}
                empty={<NoDataSection resource={'report_batch_students'} />}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="batch.title" />
                    <TextField source="student.email" label="Email" />
                    <FormattedDateTimeField source="createdAt" label="Joined At" />
                    <FormattedDateTimeField source="endsOn" label="Expired At" />
                    <TextField source="student.phone" label="Phone" />
                </Datagrid>
            </List>
        </DataProviderContext.Provider>
    );
};
export default ReportBatchStudentList;
